import React from 'react';
import DeleteOutlineIcon from '@mui/icons-material//Delete';
import { styled } from '@mui/material';
import { Box, Grid, IconButton, Typography } from '@mui/material';
import theme from 'theme';
import FormInput from './FormInput';
import { AdditionalInput, ModalItemBoxProps } from './types';

const PREFIX = 'ModalItemBox';

const classes = {
  title: `${PREFIX}-title`,
  deleteButton: `${PREFIX}-deleteButton`,
};

const StyledBox = styled(Box)({
  [`& .${classes.title}`]: {
    fontWeight: 700,
  },
  [`& .${classes.deleteButton}`]: {
    color: theme.palette.grey[400],
    marginLeft: '14px',
    top: '-5px',
  },
});

const ModalItemBox = ({
  index,
  item,
  handleInputChange,
  setIsMaxCharactersError,
  formValues,
  setFormValues,
  inputLabel,
  attribute,
  additionalInputs = [],
}: ModalItemBoxProps) => {
  const handleRemoveItem = () => {
    const formValueKey = attribute as keyof typeof formValues;
    if (Array.isArray(formValues[formValueKey])) {
      setFormValues({
        ...formValues,
        [attribute]: formValues[formValueKey].filter((_, i) => i !== index),
      });
    }
  };

  const getInputValue = (input: AdditionalInput) => {
    const validKeys = ['name', 'description'] as const;
    return validKeys.includes(input.name as any) ? (item?.[input.name as 'name' | 'description'] ?? '') : '';
  };

  return (
    <StyledBox mt={2} mb={2} border={1} borderColor={theme.palette.grey[400]} borderRadius={4} p={1} pb={0}>
      <Grid container alignItems="center">
        <Grid item xs={12}>
          <FormInput
            name="name"
            label={
              <Grid container alignItems="center">
                <Grid item xs={11}>
                  <Typography variant="body1" gutterBottom style={{ fontWeight: 700 }}>
                    {inputLabel}
                  </Typography>
                </Grid>
                <Grid item xs={1}>
                  <IconButton
                    className={classes.deleteButton}
                    onClick={handleRemoveItem}
                    aria-label="delete"
                    size="small">
                    <DeleteOutlineIcon />
                  </IconButton>
                </Grid>
              </Grid>
            }
            placeholder={inputLabel}
            value={item?.name || ''}
            handleInputChange={e => handleInputChange(index, e)}
            maxCharacters={additionalInputs[0]?.maxCharacters ?? 50}
            setIsMaxCharactersError={setIsMaxCharactersError}
            marginButton={2}
          />
          {additionalInputs.map((input, i) => (
            <FormInput
              key={input.id ?? i}
              name={input.name}
              label={input.label}
              placeholder={input.placeholder}
              value={getInputValue(input)}
              handleInputChange={e => handleInputChange(index, e)}
              maxCharacters={input.maxCharacters}
              setIsMaxCharactersError={setIsMaxCharactersError}
              marginButton={2}
            />
          ))}
        </Grid>
      </Grid>
    </StyledBox>
  );
};

export default ModalItemBox;
